import React, { useEffect, Fragment, useState } from 'react';
import { Button, Row, Col, Form, message, Upload, Space } from 'antd';
import FormGroup from 'Molecules/FormGroup';
import { useForm } from 'react-hook-form';
import { useTranslate } from 'Translate';

const _ = require('lodash');

export default (props) => {
  const { id, editOrganization, reloadApi, allowedEdit, data } = props;
  const { control, formState: { errors }, handleSubmit, setValue } = useForm();
  const i18n = useTranslate();
  const { t } = i18n;

  const formFields = [
    {
      name: 'ready_to_pickup_timer',
      label: <><div style={{marginRight: "5px"}}>{t("System.ready_pickup_timer")}</div><span className='c-gray'>{t("in_secs")}</span></>,
      req: false,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      number: true,
      nostep: true,
      min: 0,
      tips: "Input 0 will turn off the timer.",
      static: !allowedEdit
    },
    {
      name: 'missed_collection_timer',
      label: <><div style={{marginRight: "5px"}}>{t("System.miss_collect_timer")}</div><span className='c-gray'>{t("in_secs")}</span></>,
      req: false,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      number: true,
      nostep: true,
      min: 0,
      tips: "Input 0 will turn off the timer.",
      static: !allowedEdit
    },
    {
      name: 'close_order_timer',
      label: <><div style={{ marginRight: "5px" }}>{t("System.close_order_timer")}</div><span className='c-gray'>{t("in_secs")}</span></>,
      req: false,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      number: true,
      min: 0,
      tips: "Input 0 will turn off the timer.",
      static: !allowedEdit
    },
    {
      name: 'fa_remark_char_limit',
      label: t("System.kitchen_remark_char_limit"),
      req: false,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 100%',
      number: true,
      static: !allowedEdit
    }
  ];

  useEffect(() => {
    if (data && 'id' in data) {
      setValue('ready_to_pickup_timer', data.ready_to_pickup_timer);
      setValue('missed_collection_timer', data.missed_collection_timer);
      setValue('close_order_timer', data.close_order_timer);
      setValue('fa_remark_char_limit', data.fa_remark_char_limit)
    }
  }, [data]);

  const onFinish = async (val) => {
    props.setLoading(true);
    const payload = {
      id: id,
      kds: 1,
      ready_to_pickup_timer: val?.ready_to_pickup_timer,
      missed_collection_timer: val?.missed_collection_timer,
      close_order_timer: val?.close_order_timer,
      fa_remark_char_limit: val?.fa_remark_char_limit
    }

    await editOrganization(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("Success.update_receipt_setting"));
        reloadApi()
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message);
    })
  };

  return (
    <Form layout="vertical" onFinish={handleSubmit(onFinish)}>
      <Row gutter={[20, 30]}>
        {formFields.map((item, idx) => (
          <Fragment key={idx}>
            <FormGroup item={item} control={control} errors={errors} />
          </Fragment>
        ))}
        {
          allowedEdit &&
          <Col span={24} className='text-right'>
            <Button size="large" htmlType='submit' className='green-btn attendance-success'>{t("General.save")}</Button>
          </Col>
        }
      </Row>
    </Form>
  )
}